module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_c('p', {
    staticClass: "noindentb"
  }, [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UR HEARTFELT THANKS")]), _vm._v(" go to the following persons for their invaluable assistance throughout the writing of this book:")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Ivane Béatrice Bellocq, Sylvie Beltrando, Philippe Bonnet, Jean-Yves Bosseur, Florence Bourdon, Frédérique Cambreling, Gilles Carré, Bernard Cavanna, Bertrand Chavarrià-Aldrete, Isabelle Daups, Rhodri Davies, Félicité De Lalande, François Decarsin, Anne Dessus, Bernard de Vienne, Mary Fata, Martine Flaissier, Marie-Hélène Fournier, Jakez François, Vanessa Gerkens, Bruno Giner, Bastien Golliard, Béatrice Guillermin, June Han, Ursula Holliger, Sonja Inglefield, Philippe Leroux, Anja Linder, Zad Moultaka, Xenia Narati, Jean-Pierre Néré, Ghislaine Petit-Volta, Michèle Reverdy, François Rossé, Christophe Saunière, Philippe Schoeller, Michel Sendrez, Kazuko Gao Shinozaki, Ayako Shinozaki, Isabelle Spiers, Ernestine Stoop, Brigitte Sylvestre, Christophe Truant, Angelica Vazquez, Claire Vial, Ann Yeung")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Laure Marcel-Berlioz, Corinne Monceau, and all the CDMC team")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Germaine Tissier-Grandpierre Foundation")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96f2e200","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Acknowledgement.vue
// module id = 75
// module chunks = 0